import { CategoryReference, InternalStockItemsQuery, ManufacturerReference } from "../../inventory/models/models";
import { Box, createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import TableToolbar from "../../../shared/components/tables/TableToolbar";
import { classNames } from "../../../shared/models/models";
import TableToolbarSearch from "../../../shared/components/tables/TableToolbarSearch";
import TableToolbarSelect from "../../../shared/components/tables/TableToolbarSelect";
import { productCondition, ProductConditionCode } from "../../../common/models/CommonModels";
import useTranslation from "../../../shared/hooks/useTranslation";

type InternalStockItemsTableToolbarProps = {
  query: InternalStockItemsQuery;
  categories: CategoryReference[];
  manufacturers: ManufacturerReference[];
  onChange: (query: InternalStockItemsQuery) => void;
  className?: string;
};

const InternalStockItemsTableToolbar = ({
  query,
  categories,
  manufacturers,
  onChange,
  className
}: InternalStockItemsTableToolbarProps) => {
  const { translate } = useTranslation("myMachinery");
  const { translate: tCommon } = useTranslation("common");

  const conditionOptions = [
    ProductConditionCode.new,
    ProductConditionCode.refit,
    ProductConditionCode.used,
    ProductConditionCode.notApplicable
  ].map((x) => ({ id: x, name: translate(`productCondition.${productCondition(x)}`), checked: query?.conditionCode === x }));

  const handleQueryChange = (query: InternalStockItemsQuery): void => {
    if (onChange) {
      onChange(query);
    }
  };

  const handleSearch = (value?: string) => {
    handleQueryChange({ ...query, search: value });
  };

  const handleCategoryChange = (categoryId: string) => {
    handleQueryChange({ ...query, categoryId: categoryId ? categoryId : undefined });
  };

  const handleManufacturerChange = (manufacturerId: string) => {
    handleQueryChange({ ...query, manufacturerId: manufacturerId ? manufacturerId : undefined });
  };

  const handleConditionCodeChange = (conditionCode?: ProductConditionCode) => {
    handleQueryChange({ ...query, conditionCode: conditionCode ? conditionCode : undefined });
  };

  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <TableToolbar className={classNames("flex items-center justify-between", className)}>
        <Box className="grid grid-cols-5 gap-4 w-full">
          <Box className="col-span-2">
            <TableToolbarSearch
              placeholder={tCommon("searchByNumberOrDescription")}
              value={query?.search}
              onChange={handleSearch}
              width="100%"
            />
          </Box>

          <Box className="col-span-1 w-full">
            <TableToolbarSelect
              label={translate("category")}
              items={categories}
              value={query?.categoryId}
              onChange={handleCategoryChange}
              widthFull={true}
            />
          </Box>

          <Box className="col-span-1">
            <TableToolbarSelect
              label={tCommon("brand")}
              items={manufacturers}
              value={query?.manufacturerId}
              onChange={handleManufacturerChange}
              widthFull={true}
            />
          </Box>

          <Box className="col-span-1">
            <TableToolbarSelect
              label={tCommon("condition")}
              items={conditionOptions}
              value={query?.conditionCode}
              onChange={handleConditionCodeChange}
              widthFull={true}
            />
          </Box>
        </Box>
      </TableToolbar>
    </ThemeProvider>
  );
};
export default InternalStockItemsTableToolbar;
